export default __webpack_public_path__ + "static/Entenda0097-451f719bf507b3a49ea4fb7788fb47e9.jpg";